export default {
  title: "",
  subtitle: "Create transactions",
  path: "transaction_create",
  paragraphs: [
    "All types of transactions – Payins, Payouts, Conversions, Settlements - use the same endpoint, the only changes are in the currencies, bank account and subject ids.",
    "For payin transactions this endpoint will be used for payment methods that require more information than only the registration of the customer. For example, a Pix payment done directly for the Pix key shared with the customer does not require to be created on your side, you only need to have the customer registered for us to reconcile the payment. The same with normal SPEI transactions, where you only share your bank details and the customer pays directly to that CLABE.",
    "However, if you intend to use Credit Card, Boleto, Dynamic Pix, Dynamic Clabe and PSE this endpoint must be used."
  ],
  request: {
    method: "POST",
    endpoint: "/transactions",
  },
  parameterPayload: [
    {
      name: "transaction",
      type: "object",
      required: true,
      description: "transaction data containing at least the following required values:"
    },
    {
      name: "transaction.currency",
      type: "string",
      required: true,
      description: "currency of the amount to be sent to FacilitaPay or deducted from an internal bank account balance (ISO 4217 format)"
    },
    {
      name: "transaction.value",
      type: "string",
      required: true,
      description: "Amount to be sent to FacilitaPay (PIX / TED / WIRE) or deducted from an internal bank account balance"
    },
    {
      name: "transaction.exchange_currency",
      type: "string",
      required: true,
      description: "The \"destination\" currency also in (ISO 4217 format). When currency and exchange_currency are the same, no conversion will be performed and the destination would be an internal bank account"
    },
    {
      name: "transaction.from_bank_account_id",
      type: "string",
      required: true,
      description: "Source bank account UUID"
    },
    {
      name: "transaction.to_bank_account_id",
      type: "string",
      required: true,
      description: "Destination bank account UUID. Its currency must match the currency informed on the exchange_currency attribute. It can be the partner's internal bank account or a physical bank account of the customer. In the later case, a wire will be performed to the specified customer's bank account."
    },
    {
      name: "transaction.subject_id",
      type: "string",
      required: true,
      description: "The ID of the person or company involved in the transaction. It must be the customer ID (previously registered using the /subject/people or /subject/companies endpoints) when the transaction involves a customer or the partner company ID when it is regarding a deposit, withdrawal, or exchange between internal bank accounts not involving its customers."
    },
    {
      name: "transaction.exchange_under_request",
      type: "boolean",
      required: false,
      description: "When true, sets the transaction to be exchanged only when requested by you, so the desired rate can be chosen. Otherwise the FX rate will be closed at the time of the conversion by our back-office staff, which can allow small fluctuations on its value."
    },
    {
      name: "transaction.use_dynamic_pix",
      type: "boolean",
      required: false,
      description: "Needed if you need to make a Pix transaction with a preset value and obtain a dynamic link that may be used to create a QR Code to send to your customer. Refer to the Pix section below."
    },
     {
      name: "transaction.id*",
      type: "UUID",
      required: false,
      description: "Custom ID for the transaction, you can set it here. If not, it will be generated automatically by API"
    },
    {
      name: "transaction.meta",
      type: "json",
      required: false,
      description: "Any custom information related to your system you may want to attach to the transaction."
    }
  ],
  footerNotes: 'id*: It is not mandatory, but it is recommended to use in cases of send mutiples accidentally you can garantte the uniqueness of the transaction. If you do not set it, the API will generate a UUID for you.',
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionCreate.js